/**
 * Simple but secure token generator that produces different tokens each time
 * @param key The secret key
 * @returns A time-limited token
 */
export function generateShortLivedToken(key) {
  // Use a timestamp for expiration
  var timestamp = Math.floor(Date.now() / 1000);
  var expiryTime = timestamp + 60; // 1 minute validity
  // Add a nonce to ensure uniqueness

  var nonce = generateNonce(); // Create a signature

  var data = "".concat(expiryTime, ":").concat(nonce);
  var signature = createSignature(key, data);
  return "".concat(expiryTime, ":").concat(nonce, ":").concat(signature);
}
/**
 * Verifies a token generated by generateShortLivedToken
 * @param token The token to verify
 * @param key The secret key used to generate the token
 * @returns true if the token is valid and not expired, false otherwise
 */

export function verifyShortLivedToken(token, key) {
  if (!token || typeof token !== 'string') {
    return false;
  } // Split the token into its components


  var parts = token.split(':');

  if (parts.length !== 3) {
    return false;
  }

  var expiryTimeStr = parts[0];
  var nonce = parts[1];
  var signature = parts[2];

  if (!expiryTimeStr || !nonce || !signature) {
    return false;
  } // Check if the token is expired


  var currentTime = Math.floor(Date.now() / 1000);
  var expiryTime = parseInt(expiryTimeStr, 10);

  if (isNaN(expiryTime) || expiryTime < currentTime) {
    return false;
  } // Verify the signature


  var data = "".concat(expiryTimeStr, ":").concat(nonce);
  var expectedSignature = createSignature(key, data);
  return signature === expectedSignature;
}
/**
 * Generates a random nonce
 * @returns A random string
 */

function generateNonce() {
  // Generate a random number and convert to base36 (alphanumeric)
  return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
}
/**
 * Creates a signature for the given data using the key
 * @param key The secret key
 * @param data The data to sign
 * @returns A signature string
 */


function createSignature(key, data) {
  var hash = 0;
  var str = key + data;

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash |= 0; // Convert to 32bit integer
  } // Add another layer of hashing with different parameters


  var hash2 = 5381;

  for (var _i = 0; _i < str.length; _i++) {
    var _char2 = str.charCodeAt(_i);

    hash2 = (hash2 << 5) + hash2 + _char2;
    hash2 |= 0;
  } // Combine hashes and convert to hex


  return ((hash ^ hash2) >>> 0).toString(16).padStart(8, '0');
}